export default "__VITE_ASSET__BciHiHgA__"